export default __webpack_public_path__ + "static/media/arrow_up_orange.svg.63f9110f.svg";